import { Stack } from 'components/Stack'
import { styled } from 'stitches.config'

export const Step2Root = styled('div', {
  paddingBottom: '$4',
  px: '$3',

  '& label': {
    display: 'block',
  },
})

export const Separator = styled('hr', {
  borderColor: '$tertiary-300',
  borderWidth: '1px',
  borderTop: '0px',
  width: '100%',
})

export const RadioGroupContainer = styled('div', {
  width: '100%',
  gap: '$3',

  '@bp1': {
    maxWidth: '400px',
  },

  '@bp2': {
    maxWidth: '492px',
  },

  '& .body-condition > label:first-child': {
    maxWidth: '360px',
    margin: 'auto',
  }
})

export const CTAContainer = styled(Stack, {
  '& a': {
    textDecoration: 'underline',
    color: '$accent-black',
    '&:hover': {
      color: '$primary-500',
    },
    '&:active': {
      color: '$primary-700',
    },

    '@bp1': {
      textDecoration: 'none',
    },
  },

  marginTop: '$5',
})

export const LoseGainContainer = styled('div', {
  width: '100%',
  '& > div': {
    width: '100%',
  }
})